import React, { useEffect, useRef } from "react";
import "./chart.css";

const Chart = React.memo(({ item }) => {
  const { total_step, current_step, step_name } = item;

  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    let ctx = canvas.getContext("2d");
    let lastend = Math.PI * -0.5;
    const data = [current_step, total_step - current_step];
    let myTotal = total_step;
    const myColor = ["#f8cd60", "#eeeeee"];

    for (var i = 0; i < data.length; i++) {
      ctx.fillStyle = myColor[i];
      ctx.beginPath();
      ctx.moveTo(canvas.width / 2, canvas.height / 2);
      ctx.arc(
        canvas.width / 2, // x
        canvas.height / 2, // y
        canvas.height / 2, // radius
        lastend, // startingAngle (radians)
        lastend + Math.PI * 2 * (data[i] / myTotal), // endingAngle (radians)
        false // antiClockwise (boolean)
      );
      ctx.lineTo(canvas.width / 2, canvas.height / 2);
      ctx.fill();
      lastend += Math.PI * 2 * (data[i] / myTotal);
    }
  }, [item]);

  return (
    <div className="pt-4 pt-md-3">
      <canvas ref={canvasRef} width="300" height="300"></canvas>
      <div className="piechart">
        <div className="step">現在のステップ</div>
        <div className="per-step py-4">
          {current_step}/{total_step}
        </div>
        <div title={step_name} className="step-name">
          <span>{step_name}</span>
        </div>
      </div>
    </div>
  );
});

export default Chart;
